


import spartaBootstrapUtility from "@sparta.global.utilities/sparta-bootstrap-utility/dist/es5.js"
import tagManagerUtility from "@sparta.global-vtim.utilities/tag-manager-utility/dist/es5.js"



window.spaParams = window.spaParams || {};
window.spaParams.dynamicImportMap = {
  modules: [
    {
      name: "@sparta.secure-alumni-ah-signon.modules/ah-login-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/secure-alumni-ah-signon-ah-login-module-es5" */ "@sparta.secure-alumni-ah-signon.modules/ah-login-module/dist/es5.js" ),import( /* webpackChunkName: "spa-assets/on-demand/secure-alumni-ah-signon-ah-login-module-styles" */ "@sparta.secure-alumni-ah-signon.modules/ah-login-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.global.vendors/vue",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vue" */ "@sparta.global.vendors/vue" )}
    },
    {
      name: "@sparta.global.vendors/vuex",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vuex" */ "@sparta.global.vendors/vuex" )}
    },
    {
      name: "@sparta.global.vendors/vue-router",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vue-router" */ "@sparta.global.vendors/vue-router" )}
    }
  ],
  sharedComponents: [
    {
      name: "@sparta.secure-alumni-ah-signon.shared-components/ah-login-shared-component",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/secure-alumni-ah-signon-ah-login-shared-component-es5" */ "@sparta.secure-alumni-ah-signon.shared-components/ah-login-shared-component/dist/es5.js" )}
    },
    {
      name: "@sparta.secure-alumni-ah-signon.shared-components/ah-identity-verification-shared-component",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/secure-alumni-ah-signon-ah-identity-verification-shared-component-es5" */ "@sparta.secure-alumni-ah-signon.shared-components/ah-identity-verification-shared-component/dist/es5.js" )}
    },
    {
      name: "@sparta.secure-alumni-ah-signon.shared-components/ah-stepup-shared-component",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/secure-alumni-ah-signon-ah-stepup-shared-component-es5" */ "@sparta.secure-alumni-ah-signon.shared-components/ah-stepup-shared-component/dist/es5.js" )}
    },
    {
      name: "@sparta.secure-alumni-ah-signon.shared-components/ah-contact-verification-shared-component",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/secure-alumni-ah-signon-ah-contact-verification-shared-component-es5" */ "@sparta.secure-alumni-ah-signon.shared-components/ah-contact-verification-shared-component/dist/es5.js" )}
    },
    {
      name: "@sparta.secure-alumni-ah-signon.shared-components/ah-credential-creation-shared-component",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/secure-alumni-ah-signon-ah-credential-creation-shared-component-es5" */ "@sparta.secure-alumni-ah-signon.shared-components/ah-credential-creation-shared-component/dist/es5.js" )}
    }
  ],
  jcrs: [
    {
      name: "site/secure-alumni-ah-signon/module-specific/ah-login-module/en/login-client-config.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-secure-alumni-ah-signon-module-specific-ah-login-module-en-login-client-config.json" */ "file:///apps/wt/webtools/webtools_build_server/tmp/8C4C8B32/build/sit1/site/auth/alumni/signon/spa-assets/data/site-secure-alumni-ah-signon-module-specific-ah-login-module-en-login-client-config-en-T1774895336842.json" )}
    },
    {
      name: "site/secure-alumni-ah-signon/module-specific/ah-login-module/en/login-page.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-secure-alumni-ah-signon-module-specific-ah-login-module-en-login-page.json" */ "file:///apps/wt/webtools/webtools_build_server/tmp/8C4C8B32/build/sit1/site/auth/alumni/signon/spa-assets/data/site-secure-alumni-ah-signon-module-specific-ah-login-module-en-login-page-en-T1774895336842.json" )}
    },
    {
      name: "site/secure-alumni-ah-signon/module-specific/ah-login-module/en/error-messages.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-secure-alumni-ah-signon-module-specific-ah-login-module-en-error-messages.json" */ "file:///apps/wt/webtools/webtools_build_server/tmp/8C4C8B32/build/sit1/site/auth/alumni/signon/spa-assets/data/site-secure-alumni-ah-signon-module-specific-ah-login-module-en-error-messages-en-T1774895336842.json" )}
    }
  ]
}




// Add fingerprint spa-map.json into spaParams

// Initialize page
;(function() {
  console.log('INIT PAGE')
  console.log('before - execute boot functions')
  var bootExecs = [];
  bootExecs.push(function() { return spartaBootstrapUtility.init(arguments); });
  bootExecs.reduce(function(cur, next) {
    return cur.then(next);
  }, Promise.resolve()).then(function() {
    console.log('after - execute boot functions')
  });
})();
